const ADD_TO_QUEUE = 'buttons_add_to_queue';
const IN_QUEUE = 'buttons_in_queue';
const REMOVE_FROM_QUEUE = 'buttons_remove_from_queue';

export { ADD_TO_QUEUE, IN_QUEUE, REMOVE_FROM_QUEUE };
